import { createSlice } from "@reduxjs/toolkit";

export const lockerFeeTableSlice = createSlice({
  name: "lockerFeeTable",
  initialState: {
    lockerFeeTableData: [],
  },
  reducers: {
    setLockerFeeData: (state, actions) => {
      state.lockerFeeTableData = actions.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setLockerFeeData } = lockerFeeTableSlice.actions;

export default lockerFeeTableSlice.reducer;
